import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCloud = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M13.118 5.752a5.645 5.645 0 0 0-1.985-.005 5.373 5.373 0 0 0-1.822.673c-1.107.66-1.842 1.668-2.09 2.775a1.08 1.08 0 0 1-1.055.844c-1.077 0-2.101.41-2.849 1.125a3.679 3.679 0 0 0-1.155 2.658c0 .988.41 1.945 1.155 2.658a4.124 4.124 0 0 0 2.849 1.125h12.97a2.702 2.702 0 1 0 0-5.404h-1.08A1.08 1.08 0 0 1 17 10.883c.123-.549.125-1.113.005-1.663s-.36-1.08-.712-1.558a4.716 4.716 0 0 0-1.359-1.227 5.365 5.365 0 0 0-1.817-.683Zm-2.36-2.134a7.807 7.807 0 0 1 2.747.008 7.52 7.52 0 0 1 2.55.96 6.876 6.876 0 0 1 1.978 1.793 6.251 6.251 0 0 1 1.085 2.382c.092.422.138.85.138 1.28a4.864 4.864 0 0 1-.12 9.726H6.166a6.285 6.285 0 0 1-4.343-1.724A5.84 5.84 0 0 1 0 13.823a5.84 5.84 0 0 1 1.823-4.221A6.256 6.256 0 0 1 5.346 7.93c.517-1.39 1.528-2.573 2.856-3.366a7.535 7.535 0 0 1 2.556-.946Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCloud);
export default ForwardRef;
